import { Capacitor, registerPlugin } from "@capacitor/core";
import { pushNativeRegister, pushNativeUnregister } from "@/lib/api";

// Native-only plugin (iOS/Android via @capacitor-firebase/messaging). No web implementation on purpose.
const FirebaseMessaging = registerPlugin("FirebaseMessaging");
const TOKEN_KEY = "native_push_token";

export const isNativeApp = () => Capacitor.isNativePlatform();
export const nativePlatform = () => Capacitor.getPlatform();

async function registerToken(token) {
  await pushNativeRegister({ token, platform: nativePlatform(), user_agent: navigator.userAgent });
  localStorage.setItem(TOKEN_KEY, token);
}

export async function nativePushPermission() {
  const p = await FirebaseMessaging.checkPermissions();
  return p.receive;
}

export async function enableNativePush() {
  let perm = await FirebaseMessaging.checkPermissions();
  if (perm.receive !== "granted") perm = await FirebaseMessaging.requestPermissions();
  if (perm.receive !== "granted") throw new Error("Bildirim izni verilmedi. Telefon ayarlarindan UcarFlow bildirimlerini acin.");
  if (nativePlatform() === "android") {
    try {
      await FirebaseMessaging.createChannel({ id: "ucarflow_default", name: "UcarFlow Bildirimleri", description: "Yeni musteri ve gunluk ozet bildirimleri", importance: 5, sound: "default", vibration: true, lights: true });
    } catch { /* channel may already exist */ }
  }
  const { token } = await FirebaseMessaging.getToken();
  await registerToken(token);
  return token;
}

export async function disableNativePush() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) await pushNativeUnregister(token).catch(() => {});
  try { await FirebaseMessaging.deleteToken(); } catch { /* ignore */ }
  localStorage.removeItem(TOKEN_KEY);
}

export async function isNativePushEnabled() {
  if (!isNativeApp()) return false;
  try {
    const perm = await nativePushPermission();
    return perm === "granted" && !!localStorage.getItem(TOKEN_KEY);
  } catch { return false; }
}

export async function initNativePush({ navigate, onForeground } = {}) {
  if (!isNativeApp()) return;
  try {
    await FirebaseMessaging.removeAllListeners();
    await FirebaseMessaging.addListener("tokenReceived", ({ token }) => registerToken(token).catch(() => {}));
    await FirebaseMessaging.addListener("notificationReceived", (e) => onForeground && onForeground(e.notification || {}));
    await FirebaseMessaging.addListener("notificationActionPerformed", (e) => {
      const url = e?.notification?.data?.url;
      if (url && url.startsWith("/") && navigate) navigate(url);
    });
    const perm = await nativePushPermission();
    if (perm === "granted") {
      const { token } = await FirebaseMessaging.getToken();
      await registerToken(token);
    }
  } catch (e) {
    console.warn("Native push init failed", e);
  }
}
